'use client';

import CategoryPage from '@/joystagram-components/components/consumer/CategoryPage';
import WarehouseIdHydrator from '@/joystagram-components/global-state/warehouseIdForUser/WarehouseIdHydrator';

// The client half of a descriptor-sourced Algolia listing page (`/instock/`,
// `/flash-sale/`, `/clearance/`). Unlike CategoryPageClient there is no
// `serverCategoryData`: these page types set `metadataSource`/`facetSource` to
// `DESCRIPTOR`, so all metadata comes from the descriptor and there is no
// Alexandria page to prefetch. The warehouse id is hydrated from the request
// because warehouse-dependent products must never go through the slug-keyed
// `'use cache'` helpers.
//
// The hydrator wraps the page rather than sitting beside it: useHydrateAtoms
// only wins over a reader that mounts after it, and as a sibling that ordering
// would rest on nothing but element order (see WarehouseIdHydrator). Without
// the nesting CategoryPage could build its first Algolia `filters` from the
// atom's default warehouse instead of the request's.
const AlgoliaListingPageClient = ({
  serverWarehouseId,
  algoliaUserToken,
  algoliaAnalyticsParams,
  slug,
  pageType,
}) => (
  <WarehouseIdHydrator warehouseId={serverWarehouseId}>
    <CategoryPage
      slug={slug}
      pageType={pageType}
      algoliaUserToken={algoliaUserToken}
      algoliaAnalyticsParams={algoliaAnalyticsParams}
    />
  </WarehouseIdHydrator>
);

export default AlgoliaListingPageClient;
